import type { Locale } from '../locales.ts';

/**
 * 7 trang pháp lý — MỘT mục phủ CẢ HAI ngôn ngữ.
 *
 * Bảy, không phải mười bốn: `PageRoute.slug` là `Record<Locale, string>`, nên một mục sinh ra hai
 * URL. `allPaths()` ra 14 URL từ 7 mục này.
 *
 * ⚠️ NGOẠI LỆ CÓ CHỦ Ý về slug. Docblock `routes.ts` nêu nguyện vọng *"URL tiếng Việt phải là
 * tiếng Việt — `/vi/tinh-nang`, không phải slug tiếng Anh dịch nửa vời"*. Ở đây slug tiếng Anh
 * dùng cho CẢ HAI ngôn ngữ (`/vi/terms/`, không phải `/vi/dieu-khoan/`) vì **19 URL này đã được
 * đăng ký pháp lý và đã công bố** — đổi là 404 trên URL đã index. Contract §1.1 chỉ bắt buộc
 * MỘT nguồn sự thật + gạch cuối; nó KHÔNG bắt buộc slug bản địa. Nên đây hợp contract, chỉ trái
 * một nguyện vọng viết trong chú thích.
 */
export type LegalPageId =
  | 'legal-terms'
  | 'legal-terms-v1'
  | 'legal-privacy'
  | 'legal-privacy-v1'
  | 'legal-cookies'
  | 'legal-support'
  | 'legal-delete-account';

export interface LegalPageDef {
  /** Khoá tra `docMeta`/`descriptions`: `<docKey>.<locale>` (ví dụ `terms.v1` + `.vi`). */
  readonly docKey: string;
  /** Slug dùng cho MỌI locale — xem ngoại lệ có chủ ý ở trên. */
  readonly slug: string;
  /** false ⇒ bản lưu trữ: ngoài sitemap + gắn noindex. */
  readonly indexable: boolean;
}

export const LEGAL_PAGES: Readonly<Record<LegalPageId, LegalPageDef>> = {
  'legal-terms': { docKey: 'terms', slug: 'terms', indexable: true },
  'legal-terms-v1': { docKey: 'terms.v1', slug: 'terms/v1', indexable: false },
  'legal-privacy': { docKey: 'privacy', slug: 'privacy', indexable: true },
  'legal-privacy-v1': { docKey: 'privacy.v1', slug: 'privacy/v1', indexable: false },
  'legal-cookies': { docKey: 'cookies', slug: 'cookies', indexable: true },
  'legal-support': { docKey: 'support', slug: 'support', indexable: true },
  'legal-delete-account': { docKey: 'delete-account', slug: 'delete-account', indexable: true },
};

export const LEGAL_PAGE_IDS = Object.keys(LEGAL_PAGES) as readonly LegalPageId[];

/** Khoá tra tài liệu cho một (trang × ngôn ngữ). */
export function docKeyFor(id: LegalPageId, locale: Locale): string {
  return `${LEGAL_PAGES[id].docKey}.${locale}`;
}
